// El chevron de desplegar del módulo de ventas.
//
// Estaba escrito a mano en cuatro sitios —`FacturasPedido`, dos veces en
// `CargasPedido` y `LineasRow`— con el mismo SVG y la misma rotación. Se extrae al
// añadir el quinto, que es cuando una duplicación deja de ser una casualidad.
//
// Sin `aria-expanded` ni `<button>` aquí a propósito: en los cuatro sitios el
// chevron va DENTRO de un botón que ya los lleva, y anidar botones es HTML
// inválido. Esto es sólo el icono.

interface Props {
  /** Rotado 90° cuando está abierto. */
  abierto: boolean
  /** Clases de color y tamaño. El tamaño por defecto es el de la subtabla. */
  className?: string
}

export function Chevron({ abierto, className = 'w-3 h-3' }: Props) {
  return (
    <svg
      className={`shrink-0 transition-transform duration-150 ${abierto ? 'rotate-90' : ''} ${className}`}
      viewBox="0 0 14 14"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 11l4-4-4-4" />
    </svg>
  )
}
